import {
	type ConnectorState,
	useEnabledKnowledgeSources,
} from '@atlassian/conversation-assistant-store/controllers/connectors-store';

const GOOGLE_CALENDAR_RESOURCE_TYPE = 'google-calendar-connector';
const GOOGLE_CALENDAR_SOURCES: ReadonlySet<string> = new Set([
	'google-calendar',
	'google_calendar',
]);

/**
 * Returns the Google Calendar connector entry from the connectors-store, or
 * `null` if the connector is not enabled for this tenant.
 *
 * Match by `resourceType` first (stable schema), and fall back to `source`
 * to tolerate the legacy alias.
 */
export const useGoogleCalendarConnector = (): ConnectorState | null => {
	const [sources] = useEnabledKnowledgeSources();
	return (
		sources.find(
			(c) =>
				c.resourceType === GOOGLE_CALENDAR_RESOURCE_TYPE || GOOGLE_CALENDAR_SOURCES.has(c.source),
		) ?? null
	);
};
